import { AdminRolesEnum } from '@/dashboard/enums/admin-roles';
import Merchants from '@/dashboard/admin/scenes/Merchants';
import Merchant from '@/dashboard/admin/scenes/Merchant';
import MerchantsUsage from '@/dashboard/admin/scenes/MerchantsUsage';
import Pages from '@/dashboard/admin/scenes/Pages';
import PageCompare from '@/dashboard/admin/scenes/PageCompare';
import Plans from '@/dashboard/admin/scenes/Plans';
import Payments from '@/dashboard/admin/scenes/Payments';
import Subscriptions from '@/dashboard/admin/scenes/Subscriptions';
import Submissions from '@/dashboard/admin/scenes/Submissions';
import Templates from '@/dashboard/admin/scenes/Templates';
import Template from '@/dashboard/admin/scenes/Template';
import TemplateAdd from '@/dashboard/admin/scenes/TemplateAdd';
import TemplateCategories from '@/dashboard/admin/scenes/TemplateCategories';
import TemplateCategory from '@/dashboard/admin/scenes/TemplateCategory';
import TemplateCategoryAdd from '@/dashboard/admin/scenes/TemplateCategoryAdd';
import HelpCenterSearchIntents from '@/dashboard/admin/scenes/HelpCenterSearchIntents';
import AdminActions from '@/dashboard/admin/scenes/Actions';
import StatisticLogs from '@/dashboard/admin/scenes/StatisticLogs';
import MetricLogs from '@/dashboard/admin/scenes/MetricLogs';
import IntegrationLogs from '@/dashboard/admin/scenes/IntegrationLogs';
import CalculatePageMetadata from './scenes/CalculatePageMetadata';
import BullBoard from './scenes/BullBoard';

export const ADMIN_ROUTES = [
  {
    path: '/admin/merchants',
    roles: [AdminRolesEnum.ADMIN, AdminRolesEnum.SUPPORT],
    exact: true,
    component: Merchants,
  },
  {
    path: '/admin/merchants/:sellerId',
    roles: [AdminRolesEnum.ADMIN, AdminRolesEnum.SUPPORT],
    exact: true,
    component: Merchant,
  },
  {
    path: '/admin/merchants-usage',
    roles: [AdminRolesEnum.ADMIN, AdminRolesEnum.SUPPORT],
    exact: true,
    component: MerchantsUsage,
  },
  {
    path: '/admin/pages',
    roles: [
      AdminRolesEnum.ADMIN,
      AdminRolesEnum.SUPPORT,
      AdminRolesEnum.EDITOR,
      AdminRolesEnum.DEVELOPER,
    ],
    exact: true,
    component: Pages,
  },
  {
    path: '/admin/pages/compare',
    roles: [
      AdminRolesEnum.ADMIN,
      AdminRolesEnum.SUPPORT,
      AdminRolesEnum.EDITOR,
      AdminRolesEnum.DEVELOPER,
    ],
    exact: true,
    component: PageCompare,
  },
  {
    path: '/admin/payments',
    roles: [AdminRolesEnum.ADMIN, AdminRolesEnum.SUPPORT],
    exact: true,
    component: Payments,
  },
  {
    path: '/admin/subscriptions',
    roles: [AdminRolesEnum.ADMIN, AdminRolesEnum.SUPPORT],
    exact: true,
    component: Subscriptions,
  },
  {
    path: '/admin/submissions',
    roles: [AdminRolesEnum.ADMIN, AdminRolesEnum.SUPPORT],
    exact: true,
    component: Submissions,
  },
  {
    path: '/admin/plans',
    roles: [AdminRolesEnum.ADMIN],
    exact: true,
    component: Plans,
  },
  {
    path: '/admin/templates',
    roles: [AdminRolesEnum.ADMIN, AdminRolesEnum.EDITOR, AdminRolesEnum.DEVELOPER],
    exact: true,
    component: Templates,
  },
  {
    path: '/admin/templates/new',
    roles: [AdminRolesEnum.ADMIN, AdminRolesEnum.EDITOR, AdminRolesEnum.DEVELOPER],
    exact: true,
    component: TemplateAdd,
  },
  {
    path: '/admin/templates/:templateId',
    roles: [AdminRolesEnum.ADMIN, AdminRolesEnum.EDITOR, AdminRolesEnum.DEVELOPER],
    exact: true,
    component: Template,
  },
  {
    path: '/admin/template-categories',
    roles: [AdminRolesEnum.ADMIN, AdminRolesEnum.EDITOR, AdminRolesEnum.DEVELOPER],
    exact: true,
    component: TemplateCategories,
  },
  {
    path: '/admin/template-categories/new',
    roles: [AdminRolesEnum.ADMIN, AdminRolesEnum.EDITOR, AdminRolesEnum.DEVELOPER],
    exact: true,
    component: TemplateCategoryAdd,
  },
  {
    path: '/admin/template-categories/:categoryId',
    roles: [AdminRolesEnum.ADMIN, AdminRolesEnum.EDITOR, AdminRolesEnum.DEVELOPER],
    exact: true,
    component: TemplateCategory,
  },
  {
    path: '/admin/help-center-search-intents',
    roles: [
      AdminRolesEnum.ADMIN,
      AdminRolesEnum.SUPPORT,
      AdminRolesEnum.EDITOR,
      AdminRolesEnum.DEVELOPER,
    ],
    exact: true,
    component: HelpCenterSearchIntents,
  },
  {
    path: '/admin/actions',
    roles: [AdminRolesEnum.ADMIN],
    exact: true,
    component: AdminActions,
  },
  {
    path: '/admin/statistic-logs',
    roles: [AdminRolesEnum.ADMIN, AdminRolesEnum.DEVELOPER],
    exact: true,
    component: StatisticLogs,
  },
  {
    path: '/admin/metric-logs',
    roles: [AdminRolesEnum.ADMIN, AdminRolesEnum.DEVELOPER],
    exact: true,
    component: MetricLogs,
  },
  {
    path: '/admin/integration-logs',
    roles: [AdminRolesEnum.ADMIN, AdminRolesEnum.DEVELOPER],
    exact: true,
    component: IntegrationLogs,
  },
  {
    path: '/admin/calculate-page-metadata',
    roles: [AdminRolesEnum.ADMIN, AdminRolesEnum.DEVELOPER],
    exact: true,
    component: CalculatePageMetadata,
  },
  {
    path: '/admin/queues',
    roles: [AdminRolesEnum.ADMIN, AdminRolesEnum.DEVELOPER],
    exact: true,
    component: BullBoard,
  },
];

export const ADMIN_NAV = [
  {
    name: 'Merchants',
    href: '/admin/merchants',
    roles: [AdminRolesEnum.ADMIN, AdminRolesEnum.SUPPORT],
  },
  {
    name: 'Merchants Usage',
    href: '/admin/merchants-usage',
    roles: [AdminRolesEnum.ADMIN, AdminRolesEnum.SUPPORT],
  },
  {
    name: 'Pages',
    href: '/admin/pages',
    roles: [
      AdminRolesEnum.ADMIN,
      AdminRolesEnum.SUPPORT,
      AdminRolesEnum.EDITOR,
      AdminRolesEnum.DEVELOPER,
    ],
  },
  {
    name: 'Payments',
    href: '/admin/payments',
    roles: [AdminRolesEnum.ADMIN, AdminRolesEnum.SUPPORT],
  },
  {
    name: 'Subscriptions',
    href: '/admin/subscriptions',
    roles: [AdminRolesEnum.ADMIN, AdminRolesEnum.SUPPORT],
  },
  {
    name: 'Submissions',
    href: '/admin/submissions',
    roles: [AdminRolesEnum.ADMIN, AdminRolesEnum.SUPPORT],
  },
  {
    name: 'Plans',
    href: '/admin/plans',
    roles: [AdminRolesEnum.ADMIN],
  },
  {
    name: 'Templates',
    href: '/admin/templates',
    roles: [AdminRolesEnum.ADMIN, AdminRolesEnum.EDITOR, AdminRolesEnum.DEVELOPER],
  },
  {
    name: 'Template Categories',
    href: '/admin/template-categories',
    roles: [AdminRolesEnum.ADMIN, AdminRolesEnum.EDITOR, AdminRolesEnum.DEVELOPER],
  },
  {
    name: 'Help Center Search Intents',
    href: '/admin/help-center-search-intents',
    roles: [
      AdminRolesEnum.ADMIN,
      AdminRolesEnum.SUPPORT,
      AdminRolesEnum.EDITOR,
      AdminRolesEnum.DEVELOPER,
    ],
  },
  {
    name: 'Actions',
    href: '/admin/actions',
    roles: [AdminRolesEnum.ADMIN],
  },
  {
    name: 'Statistic Logs',
    href: '/admin/statistic-logs',
    roles: [AdminRolesEnum.ADMIN, AdminRolesEnum.DEVELOPER],
  },
  {
    name: 'Metric Logs',
    href: '/admin/metric-logs',
    roles: [AdminRolesEnum.ADMIN, AdminRolesEnum.DEVELOPER],
  },
  {
    name: 'Integration Logs',
    href: '/admin/integration-logs',
    roles: [AdminRolesEnum.ADMIN, AdminRolesEnum.DEVELOPER],
  },
  {
    name: 'Calculate Page Metadata',
    href: '/admin/calculate-page-metadata',
    roles: [AdminRolesEnum.ADMIN, AdminRolesEnum.DEVELOPER],
  },
  {
    name: 'Job Queues',
    href: '/admin/queues',
    roles: [AdminRolesEnum.ADMIN, AdminRolesEnum.DEVELOPER],
  },
];

export const getNavigation = role => {
  return ADMIN_NAV.filter(item => item.roles.includes(role));
};
